import React, { useState, useEffect } from 'react';

function FadeTransition({ in: inProp, children, duration, unMountOnExit, customClass }) {
  const [isMounted, setMounted] = useState(inProp);

  useEffect(() => {
    if (inProp) {
      setMounted(true);
    }
  }, [inProp]);

  const onAnimationEnd = () => {
    if (unMountOnExit && !inProp) {
      setMounted(false);
    }
  };

  if (!isMounted) {
    return null;
  }

  return (
    <div
      className={customClass}
      style={{
        animationName: `${inProp ? 'fade-in' : 'fade-out'}`,
        animationDuration: `${duration}ms`,
        animationFillMode: 'forwards',
      }}
      onAnimationEnd={onAnimationEnd}
    >
      {children}
    </div>
  );
}

export default FadeTransition;